module.exports = {
          srcSet: __webpack_public_path__ + "9395338ec6de94de17fe43a7de7ea828-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "9395338ec6de94de17fe43a7de7ea828-66.jpg",width: 66,height: 44}],
          src: __webpack_public_path__ + "9395338ec6de94de17fe43a7de7ea828-66.jpg",
          toString:function(){return __webpack_public_path__ + "9395338ec6de94de17fe43a7de7ea828-66.jpg"},
          
          width: 66,
          height: 44
        }